import React, { useEffect } from 'react';

import DataTable from 'react-data-table-component';
import { useContext } from '../../Context';
import columns from './columns';
import NoData from './NoData';

export default function Table() {
  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  return (
    <DataTable
      title=""
      columns={columns}
      data={state.resources || []}
      noDataComponent={<NoData />}
      persistTableHead
      pagination
      paginationComponentOptions={{
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
      }}
    />

  );
}
